// Slovak overrides for the react-admin built-in messages tree (`ra.*`).
//
// There is no maintained `ra-language-slovak` package compatible with
// react-admin 5.x, so we merge English (full coverage) with this hand-rolled
// Slovak subset covering the keys that are actually visible in the UI:
// action toolbars, notifications, paging, validation, auth and empty states.
// Missing keys fall back to English automatically (allowMissing in polyglot).

const raSlovak = {
    ra: {
        action: {
            add: 'Pridať',
            add_filter: 'Pridať filter',
            back: 'Späť',
            bulk_actions: '1 položka vybraná |||| %{smart_count} položiek vybraných',
            cancel: 'Zrušiť',
            clear_array_input: 'Vymazať zoznam',
            clear_input_value: 'Vymazať hodnotu',
            clone: 'Klonovať',
            close: 'Zavrieť',
            close_menu: 'Zavrieť menu',
            confirm: 'Potvrdiť',
            create: 'Vytvoriť',
            create_item: 'Vytvoriť %{item}',
            delete: 'Zmazať',
            edit: 'Upraviť',
            expand: 'Rozbaliť',
            export: 'Exportovať',
            list: 'Zoznam',
            move_down: 'Posunúť dole',
            move_up: 'Posunúť hore',
            open_menu: 'Otvoriť menu',
            refresh: 'Obnoviť',
            remove: 'Odstrániť',
            remove_filter: 'Odstrániť filter',
            remove_all_filters: 'Odstrániť všetky filtre',
            save: 'Uložiť',
            search: 'Hľadať',
            select_all: 'Vybrať všetko',
            select_all_button: 'Vybrať všetko',
            select_row: 'Vybrať tento riadok',
            show: 'Zobraziť',
            sort: 'Zoradiť',
            undo: 'Späť',
            unselect: 'Zrušiť výber',
            update: 'Aktualizovať',
            update_application: 'Reload aplikácie',
        },
        boolean: {
            true: 'Áno',
            false: 'Nie',
            null: ' ',
        },
        page: {
            create: 'Vytvoriť %{name}',
            dashboard: 'Nástenka',
            edit: '%{name} %{recordRepresentation}',
            error: 'Niečo sa pokazilo',
            list: '%{name}',
            loading: 'Načítavanie',
            not_found: 'Nenájdené',
            show: '%{name} %{recordRepresentation}',
            empty: 'Žiadne %{name} zatiaľ.',
            invite: 'Chcete pridať?',
        },
        input: {
            file: {
                upload_several: 'Pretiahnite sem súbory alebo kliknite pre výber.',
                upload_single: 'Pretiahnite sem súbor alebo kliknite pre výber.',
            },
            image: {
                upload_several: 'Pretiahnite sem obrázky alebo kliknite pre výber.',
                upload_single: 'Pretiahnite sem obrázok alebo kliknite pre výber.',
            },
            references: {
                all_missing: 'Nepodarilo sa nájsť referencie.',
                many_missing: 'Aspoň jedna prepojená referencia už nie je dostupná.',
                single_missing: 'Prepojená referencia už nie je dostupná.',
            },
            password: {
                toggle_visible: 'Skryť heslo',
                toggle_hidden: 'Zobraziť heslo',
            },
        },
        message: {
            about: 'O aplikácii',
            are_you_sure: 'Ste si istý?',
            auth_error: 'Chyba pri overovaní vašich poverení.',
            bulk_delete_content:
                'Naozaj chcete zmazať túto položku %{name}? |||| Naozaj chcete zmazať týchto %{smart_count} položiek?',
            bulk_delete_title:
                'Zmazať %{name} |||| Zmazať %{smart_count} %{name}',
            bulk_update_content:
                'Naozaj chcete aktualizovať túto položku %{name}? |||| Naozaj chcete aktualizovať týchto %{smart_count} položiek?',
            bulk_update_title:
                'Aktualizovať %{name} |||| Aktualizovať %{smart_count} %{name}',
            clear_array_input: 'Naozaj chcete vymazať celý zoznam?',
            delete_content: 'Naozaj chcete túto položku zmazať?',
            delete_title: 'Zmazať %{name} #%{id}',
            details: 'Detaily',
            error: 'Vyskytla sa chyba pri komunikácii a požiadavka nebola dokončená.',
            invalid_form: 'Formulár nie je platný. Skontrolujte prosím chyby.',
            loading: 'Stránka sa načítava, chvíľu strpenia.',
            no: 'Nie',
            not_found: 'Zadali ste neplatnú URL alebo ste klikli na chybný odkaz.',
            yes: 'Áno',
            unsaved_changes: 'Máte neuložené zmeny. Naozaj ich chcete zahodiť?',
        },
        navigation: {
            no_results: 'Žiadne výsledky',
            no_more_results:
                'Stránka %{page} je mimo rozsah. Skúste predchádzajúcu stránku.',
            page_out_of_boundaries: 'Stránka %{page} je mimo rozsah',
            page_out_from_end: 'Nedá sa ísť ďalej',
            page_out_from_begin: 'Stránka nemôže byť menšia ako 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} z %{total}',
            partial_page_range_info: '%{offsetBegin}-%{offsetEnd} z viac ako %{offsetEnd}',
            current_page: 'Stránka %{page}',
            page: 'Ísť na stranu %{page}',
            first: 'Prvá stránka',
            last: 'Posledná stránka',
            next: 'Ďalšia stránka',
            previous: 'Predchádzajúca stránka',
            page_rows_per_page: 'Riadkov na stránku:',
            skip_nav: 'Preskočiť na obsah',
        },
        sort: {
            sort_by: 'Zoradiť podľa %{field} %{order}',
            ASC: 'vzostupne',
            DESC: 'zostupne',
        },
        auth: {
            auth_check_error: 'Pre pokračovanie sa prosím prihláste',
            user_menu: 'Profil',
            username: 'Používateľské meno',
            password: 'Heslo',
            sign_in: 'Prihlásiť sa',
            sign_in_error: 'Prihlásenie zlyhalo, skúste to znovu',
            logout: 'Odhlásiť sa',
        },
        notification: {
            updated: 'Položka aktualizovaná |||| %{smart_count} položiek aktualizovaných',
            created: 'Položka vytvorená',
            deleted: 'Položka zmazaná |||| %{smart_count} položiek zmazaných',
            bad_item: 'Nesprávna položka',
            item_doesnt_exist: 'Položka neexistuje',
            http_error: 'Chyba servera',
            data_provider_error: 'Chyba data providera. Skontrolujte konzolu pre detaily.',
            i18n_error: 'Nepodarilo sa načítať preklady pre zvolený jazyk',
            canceled: 'Akcia zrušená',
            logged_out: 'Vaše prihlásenie skončilo, prihláste sa prosím znovu.',
            not_authorized: 'Nemáte oprávnenie pre prístup k tomuto zdroju.',
            application_update_available: 'Je dostupná nová verzia.',
        },
        validation: {
            required: 'Povinné',
            minLength: 'Musí mať aspoň %{min} znakov',
            maxLength: 'Musí mať najviac %{max} znakov',
            minValue: 'Musí byť aspoň %{min}',
            maxValue: 'Musí byť najviac %{max}',
            number: 'Musí byť číslo',
            email: 'Musí byť platná e-mailová adresa',
            oneOf: 'Musí byť jedna z hodnôt: %{options}',
            regex: 'Musí zodpovedať tvaru: %{pattern}',
            unique: 'Musí byť unikátne',
        },
        saved_queries: {
            label: 'Uložené dotazy',
            query_name: 'Názov dotazu',
            new_label: 'Uložiť aktuálny dotaz...',
            new_dialog_title: 'Uložiť aktuálny dotaz ako',
            remove_label: 'Odstrániť uložený dotaz',
            remove_label_with_name: 'Odstrániť dotaz "%{name}"',
            remove_dialog_title: 'Odstrániť uložený dotaz?',
            remove_message: 'Naozaj chcete odstrániť túto položku zo zoznamu uložených dotazov?',
            help: 'Filter zoznamu a uloženie tohto dotazu pre neskôr',
        },
        configurable: {
            customize: 'Prispôsobiť',
            configureMode: 'Konfigurovať túto stránku',
            inspector: {
                title: 'Inšpektor',
                content: 'Zamerajte sa na prvok rozhrania pre konfiguráciu',
                reset: 'Resetovať nastavenia',
                hideAll: 'Skryť všetko',
                showAll: 'Zobraziť všetko',
            },
            Datagrid: { title: 'Tabuľka', unlabeled: 'Nepomenovaný stĺpec #%{column}' },
            SimpleForm: { title: 'Formulár', unlabeled: 'Nepomenované pole #%{input}' },
            SimpleList: {
                title: 'Zoznam',
                primaryText: 'Primárny text',
                secondaryText: 'Sekundárny text',
                tertiaryText: 'Terciárny text',
            },
        },
    },
} as const;

export default raSlovak;
